import {MutationTree} from "vuex";
import * as moment from "moment";
import Tenant from '../ts/Tenant';
import TenantFeature from "../ts/Feature";

export const mutations: MutationTree<any> = {

    /**
     * Set tenant lists loading state
     *
     * @param state
     * @param payload
     */
    setLoading(state: any, payload: boolean) {
        state.tenantsLoading = payload;
    },

    /**
     * Set tenants data
     *
     * @param state
     * @param payload
     */
    setData(state: any, payload: Array<Tenant>) {
        state.tenants = payload;
        state.tenantsExpire = moment().add(15, 'minutes');
    },

    /**
     * Set saving state
     *
     * @param state
     * @param payload
     */
    setSaving(state: any, payload: boolean) {
        state.tenantSaving = payload;
    },

    /**
     * Add tenant to the store
     *
     * @param state
     * @param payload
     */
    addTenant: function (state: any, payload: Tenant) {
        state.tenants.push(payload)
    },

    /**
     * Update tenant record in store
     *
     * @param state
     * @param payload
     */
    updateTenant: function (state: any, payload: Tenant) {

        let found = state.tenants.find((tenant: Tenant) => payload.uuid === tenant.uuid)

        if (found) {
            found = Object.assign(found, payload);
        } else {
            console.error("Tenant not found with UUID: " + payload.uuid);
        }
    },

    /**
     * Delete tenant
     *
     * @param state
     * @param payload
     */
    deleteTenant: function (state: any, payload: Tenant) {

        let index = state.tenants.findIndex((tenant: Tenant) => payload.uuid === tenant.uuid)

        if (index) {
            state.tenants.splice(index,1);
        } else {
            console.error("Tenant not found with UUID: " + payload.uuid);
        }
    },

    /**
     * Set features
     *
     * @param state
     * @param payload
     */
    setTenantFeatures: function (state: any, {uuid, features}) {
        state.tenantFeatures[uuid] = features.map((feature: TenantFeature) => feature.name);
    },

    setAvailableFeatures: function (state: any, payload: any) {
        state.availableFeatures = payload;
    }
}